import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Slider from "@mui/material/Slider";
//import { createMuiTheme } from "@material-ui/core/styles";
//import { ThemeProvider } from "@material-ui/styles";

{/*

const muiTheme = createMuiTheme({
  overrides: {
    MuiSlider: {
      thumb: {
        color: "yellow"
      },
      track: {
        color: "red"
      },
      rail: {
        color: "black"
      }
    }
  }
});*/}
const followersMarks = [
  {
    value: 100,
    scaledValue: "3000",
    label: "<3000"
  },
  {
    value: 200,
    scaledValue: "4000",
    label: "4000"
  },
  {
    value: 300,
    scaledValue: "5000",
    label: "5000"
  },
  {
    value: 400,
    scaledValue: "6000",
    label: ">6000"
  },
  
];

class Sliderbar1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
     // value: this.props.value,
     // min_max: [],
    };
  }

 

 
  
  render() {
    console.log("this.props.value",this.props.value)
    
    return ( 
      
      <div style={{ padding_top: "10px", padding_left: "50px", textAlign: "center" }}>
        {(this.props.collapsed ) ||((this.props.collapsed2) && (this.props.glofriskassesmentselected=='cgl' )) ? (
        
       
        <Slider
          style={{ maxWidth: 200 }}
          value={this.props.value}
          min={this.props.min}
          step={100}
          //size={"small"}
          max={this.props.max}
          marks={followersMarks}
         // color={"secondary"}
          scale={this.props.scaleValues}
          onChange={this.props.handleChangeValue}
          aria-labelledby="non-linear-slider"
        />
        ): (
          <Slider // Disabled slider
            style={{ maxWidth: 200 }}
            value={this.props.value}
            disabled
            valueLabelDisplay="auto"
            aria-labelledby="non-linear-slider"
          />
    
      
    )}
     
        
      </div>
    
    
    )
   
  }
}

export default Sliderbar1;